'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE_IDS = exports.FILE_IDS = ['fileIds'];